import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=32052b6e&scoped=true"
import script from "./ScrollPane.vue?vue&type=script&lang=js"
export * from "./ScrollPane.vue?vue&type=script&lang=js"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=32052b6e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32052b6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32052b6e')) {
      api.createRecord('32052b6e', component.options)
    } else {
      api.reload('32052b6e', component.options)
    }
    module.hot.accept("./ScrollPane.vue?vue&type=template&id=32052b6e&scoped=true", function () {
      api.rerender('32052b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/tagsView/ScrollPane.vue"
export default component.exports